import { Stack, Typography } from "@mui/material";
import { useLottie } from "lottie-react";
import NoFace from "assets/lottie/NoFace.json";

const styles = {
  boxWrapper: {
    height: "90vh",
    width: "100%",
  },
};

export function UnauthorizedPage(): JSX.Element {
  const { View: NoFaceLottie } = useLottie(
    {
      animationData: NoFace,
      loop: true,
    },
    {
      width: "200px",
      height: "200px",
    }
  );
  return (
    <Stack sx={styles.boxWrapper} display={"flex"} justifyContent="center" alignItems="center" spacing={2}>
      {NoFaceLottie}
      <Typography variant="h2">No Access</Typography>
      <Typography align="center" variant="body1">
        Can't let you past this point.
      </Typography>
    </Stack>
  );
}

export const Component = UnauthorizedPage;
